module.exports = __webpack_public_path__ + "static/media/img6.8207ab18.png";